<template>
  <section>
    <el-form-item label="维修内容">
      <el-input type="textarea" :autosize="{ minRows: 4, maxRows: 6}" size="small" v-model="form.content"></el-input>
    </el-form-item>
    <div class="clear">
      <el-col :span="12">
        <el-form-item label="维修花费">
          <el-input size="small" type="number" v-model="form.cost"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="维修状态">
          <el-select @change="forceUpdate" size="small" v-model="form.repairStatusCode" placeholder="请选择维修状态">
            <el-option v-for="item,i in repairArr" :key="i" :label="item" :value="i">
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
    </div>
    <el-form-item label="备注">
      <el-input type="textarea" :autosize="{ minRows: 4, maxRows: 6}" size="small" v-model="form.remark"></el-input>
    </el-form-item>
    <div class="clear">
      <el-col :span="12">
        <el-form-item label="业务日期">
          <el-date-picker size="small" value-format="yyyy-MM-dd" v-model="form.repairTime" type="date"
            placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="报修人">
          <span v-if="selectArr.length>0" v-html="selectArr[0].name" style="margin-right:5px;"></span>
          <el-button size="mini" type="primary" @click="addUsers(1)" plain>选择报修人</el-button>
        </el-form-item>
      </el-col>
    </div>

  </section>
</template>
<script>
  import {
    mapState
  } from "vuex";

  export default {
    computed: {
      ...mapState({
        organization: state => state.main.organization,
        contactSelectArr: state => state.main.contactSelectArr,
      })
    },
    props: ['formByFather', 'userData', 'changeType'],
    data() {
      return {
        form: {},
        repairArr: ['维修中', '已完成'],

        selectArr: []
      }
    },
    mounted() {
      this.organizationList = this.organization[0].childDepts
      this.assetInit()
    },
    methods: {
      // select刷新view
      forceUpdate(item) {
        this.$forceUpdate()
      },
      // 初始化
      assetInit() {
        this.form = this.formByFather

        console.log(this.form.repairer)
        // 报修人设置
        if (this.form.repairer) {
          this.selectArr.push(this.form.repairer)
        }
      },

      // 返回form
      getFromData() {
        this.form.repairerId = this.selectArr[0].id
        return this.form
      },

      // 选择使用人
      addUsers(type) {
        // this.leaderType = type
        let _sr = []
        // switch (type) {
        //   case 1:
        //     _sr.push(this.project.leader)
        //     break;
        // }
        this.$store.commit('set_contactSelectArr', _sr)
        this.$store.commit('set_contactShow', true)
        this.$store.commit('set_contactSingleSelect', true)
      },
    },
    watch: {
      contactSelectArr() {
        console.log(this.contactSelectArr)
        if (this.contactSelectArr.length < 1) {
          return
        }
        this.selectArr = this.contactSelectArr
        this.form.repairerId = this.selectArr[0].id
      },

      formByFather: {
        handler(newName, oldName) {
          this.assetInit()
        },
        deep: true
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/page/asset/assetRepairForm.vue